import PerformanceTestDialog from '@/components/performance-test/PerformanceTestDialog';

/**
 * Rückfrage vor dem Abmelden nach Vorlage einstellungen_profil_*_dialogAbmelden (P13, 9.A-1).
 * Gemeinsam für Einstellungen, Seitenleiste und Menü „Mehr“; abgemeldet wird ausschließlich über
 * das bestehende `signOut` des Aufrufers (`onConfirm`). Abbrechen, Escape und Klick daneben schließen nur.
 */
export default function AbmeldenDialog({ onCancel, onConfirm }: { onCancel: () => void; onConfirm: () => void }) {
  return (
    <PerformanceTestDialog title="Abmelden?" width={440} onClose={onCancel}
      actions={<>
        <button type="button" className="aur-pt-dlg-cancel" onClick={onCancel}>Abbrechen</button>
        <button type="button" className="aur-pt-dlg-ok" onClick={onConfirm}>Abmelden</button>
      </>}>
      <p>Du wirst auf diesem Gerät abgemeldet.</p>
    </PerformanceTestDialog>
  );
}
